/**
 * Adzuki.String
 * Various string functions
 */

(function String($, Adzuki)
{
	"use strict";

	var string = {};

	var entityMap = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#39;',
		'/': '&#x2F;',
		'`': '&#x60;',
		'=': '&#x3D;',
	};

	string.sanitize = function sanitize(str)
	{
		var _str = str.replace(/[&<>"'`=\/]/g, function _replace(s) {
			return entityMap[s];
		});

		return _str;
	};

	string.nl2br = function nl2br(str) {
		return str.replace(/\r\n|\r|\n/g, '<br>');
	};

	string.capitalize = function capitalize(str)
	{
		return str.charAt(0).toUpperCase() + str.slice(1);
	};

	string.ucwords = function ucwords(str)
	{
		return str.toLowerCase().replace(/\b[a-z]/g, function firstUpper(letter) {
			return letter.toUpperCase();
		});
	};

	string.decodeEntities = function decodeEntities(str)
	{
		var div = document.createElement('div');

		div.innerHTML = str;

		return div.textContent;
	};

	string.isEmail = function validateEmail(str)
	{
		// this monstrositys goal is to match the same validation for email
		// addresses as the native php version, FILTER_VALIDATE_EMAIL,
		// according to RFC 822
		// see: https://github.com/mpyw/FILTER_VALIDATE_EMAIL.js/

		// eslint-disable-next-line no-control-regex
		return (/^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\.){1,126})+(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-+[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))]))$/i).test(str);
	};

	string.slug = function createSlug(str)
	{
		// uses same logic as StringComponent->createSlug()
		return str.trim().toLowerCase().replace(/\W/g, '-');
	};

	string.formatPhoneNumber = function formatPhoneNumber(str)
	{
		var phone_number = str.replace(/[^0-9]/g, '');
		var country_code = '';
		var area_code    = '';
		var next_three   = '';
		var last_four    = '';

		if (phone_number.length > 10) {
			country_code = phone_number.substring(0, phone_number.length-10);
			area_code    = phone_number.substring(1, 4);
			next_three   = phone_number.substring(4, 7);
			last_four    = phone_number.substring(7);
			phone_number = '+' + country_code + ' (' + area_code + ') ' + next_three + '-' + last_four;
		} else if (phone_number.length === 10) {
			area_code    = phone_number.substring(0, 3);
			next_three   = phone_number.substring(3, 6);
			last_four    = phone_number.substring(6);
			phone_number = '(' + area_code + ') ' + next_three + '-' + last_four;
		} else if (phone_number.length === 7) {
			next_three   = phone_number.substring(0, 3);
			last_four    = phone_number.substring(3);
			phone_number = next_three + '-' + last_four;
		}

		return phone_number;
	};

	Adzuki.String = string;
}(jQuery, window.Adzuki || {}));
